export default __webpack_public_path__ + "static/media/geometry-artwork-9.e59127f5.webp";